import { RootState } from 'store/types';

export const communitySelector = (state: RootState) => state.community;
